import { type DrawMap } from 'leaflet'
import 'leaflet-draw'
import { type FunctionComponent } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import useDrawing from './useDrawing'
import { Variant } from '../../../../../shared/components/Button/Button'
import { POLYLINE_BUTTON_TITLE, POLYGON_BUTTON_TITLE, REMOVE_BUTTON_TITLE } from '../config'
import Icon from '../../../../../shared/components/Icon/Icon'
import Measure from '../../../../../shared/assets/icons/measure.svg'
import Polygon from '../../../../../shared/assets/icons/polygon.svg'
import Trash from '../../../../../shared/assets/icons/trash.svg'
import { MapButton } from '../../../../../shared/components/SidebarMap/styles'
import useMapVisualizations from './useMapVisualizations'

const GlobalStyle = createGlobalStyle`
  .leaflet-interactive.leaflet-mouse-marker {
    cursor: copy;

    &.leaflet-editing-icon {
      cursor: pointer;
    }
  }
`

const StyledMapButton = styled(MapButton)<{ $inEditMode?: boolean }>`
  &:first-of-type {
    border-bottom-color: var(--greyMedium);
  }

  &:nth-of-type(2) {
    border-top-color: transparent;
    border-bottom-color: ${(props) => (props.$inEditMode ? 'var(--greyMedium)' : 'var(--blue)')};
  }

  &:last-of-type {
    border-top: var(--greyMedium);
  }
`

const DrawToolPanel = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0;
`

export interface DrawToolProps {
  map: DrawMap
}

const DrawToolControl: FunctionComponent<DrawToolProps> = ({ map }) => {
  useMapVisualizations(map)
  const { createPolyline, createPolygon, inEditMode, deleteDrawing } = useDrawing(map)

  return (
    <>
      <GlobalStyle />
      <DrawToolPanel>
        <StyledMapButton
          variant={Variant.PrimaryInverted}
          onClick={createPolyline}
          title={POLYLINE_BUTTON_TITLE}
          size={44}
        >
          <Icon size={32}>
            <Measure />
          </Icon>
        </StyledMapButton>

        <StyledMapButton
          onClick={createPolygon}
          title={POLYGON_BUTTON_TITLE}
          $inEditMode={inEditMode}
          variant={Variant.PrimaryInverted}
          size={44}
        >
          <Icon size={32}>
            <Polygon />
          </Icon>
        </StyledMapButton>

        {inEditMode && (
          <StyledMapButton
            size={44}
            onClick={deleteDrawing}
            title={REMOVE_BUTTON_TITLE}
            variant={Variant.PrimaryInverted}
          >
            <Icon size={32}>
              <Trash />
            </Icon>
          </StyledMapButton>
        )}
      </DrawToolPanel>
    </>
  )
}

export default DrawToolControl
